const API_URL = 'https://lyfy.ltd';

export const visitorService = {
  checkVisitor: async (email: string) => {
    try {
      const response = await fetch(`${API_URL}/check_visitor.php?email=${encodeURIComponent(email)}`);
      const data = await response.json();
      return data.exists;
    } catch (error) {
      console.error('Error checking visitor:', error);
      return false;
    }
  },

  incrementVisitorCount: async () => {
    try {
      const response = await fetch(`${API_URL}/increment_count.php`);
      const data = await response.json();
      return data.success ? data.count : 0;
    } catch (error) {
      console.error('Error incrementing visitor count:', error);
      return 0;
    }
  },

  saveVisitorData: async (firstName: string, email: string) => {
    try {
      const params = new URLSearchParams({
        firstName,
        email
      });
      
      const response = await fetch(`${API_URL}/save_visitor.php?${params.toString()}`);
      const data = await response.json();
      return data.success;
    } catch (error) {
      console.error('Error saving visitor data:', error);
      return false;
    }
  },

  getVisitorData: async () => {
    try {
      const response = await fetch(`${API_URL}/get_visitors.php`);
      const data = await response.json();
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error('Error getting visitor data:', error);
      return [];
    }
  },

  updateVisitor: async (id: number, data: { firstName: string; email: string }) => {
    try {
      const params = new URLSearchParams({
        id: id.toString(),
        firstName: data.firstName,
        email: data.email
      });
      
      const response = await fetch(`${API_URL}/update_visitor.php?${params.toString()}`);
      const result = await response.json();
      return result.success;
    } catch (error) {
      console.error('Error updating visitor:', error);
      return false;
    }
  },

  deleteVisitor: async (id: number) => {
    try {
      const response = await fetch(`${API_URL}/delete_visitor.php?id=${id}`);
      const result = await response.json();
      return result.success;
    } catch (error) {
      console.error('Error deleting visitor:', error);
      return false;
    }
  }
}; 






